import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/documents/$templateId/fields")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$dealership/deal-packets/templates/$templateId/fields",
      params,
    })
  },
})
